import React, { FC } from "react";
import { PreferencesStatus as PreferencesStatusRenderProps } from "./types";
import { useTheme, withThemeProvider } from "@narvar/nth-hook-theme";
import { useStyles } from "./PreferencesStatusStyles";
import Icon from "../Icon";
import { Language, TextLink, Spinner } from "..";

const PreferencesStatus: FC<PreferencesStatusRenderProps> = ({
  status,
  profileStatus,
  profileLink,
}) => {
  const {
    linksNoneDefault,
    linksNoneHover,
    documentbodyNoneNone,
    bodytextDefaultNone,
  } = useTheme();

  const styles = useStyles();
  const emphasize = status !== "idle";
  const linkStyles = emphasize
    ? { fontWeight: 700, textDecorationLine: "none" }
    : {};
  const iconStyles =
    status === "error"
      ? {}
      : {
          fill:
            bodytextDefaultNone?.color ?? documentbodyNoneNone?.color ?? "#000",
        };

  return (
    <div
      className={styles.preferencesStatusWrapper}
      style={{ flexDirection: emphasize ? "column" : "row" }}>
      {status === "loading" ? (
        <Spinner />
      ) : (
        <>
          <span className={styles.preferencesStatusDescription}>
            <Icon
              icon={status === "error" ? "Error" : "Favorite"}
              {...iconStyles}
            />
            <Language
              langKey={
                status === "error"
                  ? "returnsPreferencesStatusDesc_error"
                  : status === "success" && profileStatus === "pending"
                    ? "returnsPreferencesStatusDesc_pending"
                    : "returnsPreferencesStatusDesc"
              }
            />
          </span>

          {profileLink && (
            <span className={styles.preferencesStatusLink}>
              <TextLink
                href={profileLink}
                target="_blank"
                linkStyle={{
                  sDefault: { ...linksNoneDefault, ...linkStyles },
                  sHover: { ...linksNoneHover, ...linkStyles },
                }}>
                <Language
                  langKey={
                    status === "error"
                      ? "returnsPreferencesStatusLinkText_error"
                      : status === "success" && profileStatus === "pending"
                        ? "returnsPreferencesStatusLinkText_pending"
                        : "returnsPreferencesStatusLinkText"
                  }
                />
              </TextLink>
            </span>
          )}
        </>
      )}
    </div>
  );
};

export default withThemeProvider(PreferencesStatus, {
  themeTokens: [
    "linksNoneDefault",
    "linksNoneHover",
    "documentbodyNoneNone",
    "bodytextDefaultNone",
  ],
});
